<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { STRETCH_MARKS_OPTIONS } from '../types/stretch-marks'

    export let data: Record<string, any>
</script>

<div class="stretch-scale">
    {#each STRETCH_MARKS_OPTIONS as option (option.key)}
        <div class="stretch-row" class:selected={option.key === 'rubra'}>
            <span class="stretch-label">
                {option.label}
                <span class="stretch-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <span class="stretch-desc">{option.description}</span>
        </div>
    {/each}
</div>

<style>
    .stretch-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .stretch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .stretch-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .stretch-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .stretch-row.selected .stretch-label {
        color: #1f2937;
    }
    .stretch-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .stretch-row.selected .stretch-desc {
        color: #1f2937;
    }
    .stretch-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .stretch-row.selected .stretch-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
